export const formatChartData = (data, cities, title, language) => {
  if (data && cities) {
    if (Array.isArray(data)) {
      return [
        {
          name: title,
          data,
        },
      ];
    }
    return Object.keys(data).map((key) => {
      return {
        name: cities.find((item) => item.city_id === +key)[
          language === 'ru' ? 'name' : 'transcript'
        ],
        data: data[key],
      };
    });
  }
  return [];
};
